import { appThemes } from '../../../shared/constants/appThemes';

export const DefaultCategoryColor = '#d9d9d9';

export const toCssColor = (intValue) => {
  const [r, g, b] = toBytes(intValue);

  return '#' + toHex(r) + toHex(g) + toHex(b);
};

export const toVBColor = (hexCssColor) => {
  if (hexCssColor && hexCssColor.length === 7 && hexCssColor.startsWith('#')) {
    const [red, green, blue] = [
      parseInt(hexCssColor.substring(1, 3), 16),
      parseInt(hexCssColor.substring(3, 5), 16),
      parseInt(hexCssColor.substr(5), 16),
    ];

    const bbggrr = blue + (green << 8) + (red << 16);

    return bbggrr;
  } else {
    return null;
  }
};

const toBytes = (intValue) => {
  intValue >>>= 0;
  var b = intValue & 0xff,
    g = (intValue & 0xff00) >>> 8,
    r = (intValue & 0xff0000) >>> 16,
    a = ((intValue & 0xff000000) >>> 24) / 255;
  return [r, g, b, a];
};

const toHex = (intValue) => {
  return ('0' + Number(intValue).toString(16)).slice(-2);
};

export const groupEventColors = () => {
  const appTheme = +window.ncReactThemesConfiguration['currentAppTheme'];

  switch (appTheme) {
    case appThemes.Primary:
      return ['#1ab394', '#2dabc1'];
    case appThemes.Secondary:
      return ['#20b3a4', '#b91319'];
    case appThemes.Third:
      return ['#8bc34a', '#0c907d'];
    case appThemes.Dark:
      return ['#1ab394', '#2dabc1'];
    case appThemes.Indigo:
      return ['#4caf50', '#7e57c2'];
    case appThemes.Ocean:
      return ['#4caf50', '#039be5'];
    case appThemes.Night:
      return ['#3e6f65', '#4c8994'];
    case appThemes.Platinum:
      return ['#1ab394', '#2dabc1'];
    case appTheme.Iron:
      return ['#1ab394', '#13afdf'];
    case appTheme.Ukraine:
      return ['#4caf50', '#005bbb'];
    default:
      return ['#1ab394', '#2dabc1']; //primary
  }
};

export const getEventCategoryColor = (calendarCategories, item) => {
  let itemBackgroundColor;

  if (!item.calendarCategoryId) {
    itemBackgroundColor = DefaultCategoryColor;
  } else {
    const filteredCategories = calendarCategories && calendarCategories.filter((c) => item.calendarCategoryId && c.id === item.calendarCategoryId);

    if (filteredCategories && filteredCategories.length === 1) {
      itemBackgroundColor = filteredCategories[0].color;
    } else {
      itemBackgroundColor = DefaultCategoryColor;
    }
  }

  return itemBackgroundColor;
};

export const getEventTypeColor = (item) => {
  const groupBorderColors = groupEventColors();
  return item.type === 0 ? groupBorderColors[0] : groupBorderColors[1];
};

export const categoryColors = [
  { value: '#ff0000', name: 'Red' },
  { value: '#F08080', name: 'Light coral' },
  { value: '#dd3f4e', name: 'Terra Cotta' },

  { value: '#0000ff', name: 'Blue' },
  { value: '#54b9c1', name: 'Light Blue' },
  { value: '#bbdaf6', name: 'Light Steel Blue' },
  { value: '#3cb371', name: 'Medium Sea Green' },
  { value: '#87e8de', name: 'Cyan' },

  { value: '#ee83ee', name: 'Lavender Pink' },
  { value: '#eda7c1', name: 'Mauvelous' },
  { value: '#dd6ba7', name: 'Violet Red' },

  { value: '#6a5acd', name: 'Slate Blue' },
  { value: '#d3adf7', name: 'Golden Purple ' },
  { value: '#a8a2d2', name: 'Lavender Gray' },

  { value: '#e7e84f', name: 'Mindaro' },
  { value: '#fee001', name: 'Arylide Yellow' },
  { value: '#ffa500', name: 'Orange' },
];
